import React from 'react';
import { Row, Col, Form, Button, Image, Card } from 'react-bootstrap';

export default ({ performance }) => {
   
    return <div className="performance-div p-0">
        <div className="perf-outer-div">
            <p className="perf-head-line">Performance Summary</p>
            <Row className="flex-center">
                <Col lg={4} md={4} sm={5} xs={5}>
                    <p className="perf-rating-header">{performance?.totalRating?performance?.totalRating:"N/A"}
                    <span className="p-0 m-0">
                        <img className="star-rating"
                            srcset="img/star@2x.png 2x, img/star@3x.png 3x"
                            src={require('./../../assets/icons/star1.png')} alt="star1"></img>
                    </span>
                    </p>
                    <p className="perf-rating-body">Total rating</p>
                </Col>
                <Col lg={5} md={5} sm={3} xs={3}>
                    <p className="perf-rating-header">{performance?.totalReview?performance?.totalReview:"0"}</p>
                    <p className="perf-rating-body">Total reviews</p>
                </Col>
                <Col lg={3} md={3} sm={4} xs={4}>
                    <p className="perf-rating-header">{performance?.responseRate?performance?.responseRate:"0%"}</p>
                    <p className="perf-rating-body">Response rate</p>
                </Col>
            </Row>
        </div>
        <div className="perf-hr-style"/>
        <div className="perf-outer-div">
            <Row className="flex-center">
                <Col lg={4} md={4} sm={5} xs={5}>
                    <p className="perf-rating-header">£ {performance?.lastMonthEarnings?performance?.lastMonthEarnings:"0.00"}</p>
                    <p className="perf-rating-body">December earnings</p>
                </Col>
                <Col lg={5} md={5} sm={3} xs={3}>
                    <p className="perf-rating-header">{performance?.profileViews?performance?.profileViews:"0"}</p>
                    <p className="perf-rating-body">30- Day profile views</p>
                </Col>
                <Col lg={3} md={3} sm={4} xs={4}>
                    <p className="perf-rating-header">{performance?.upcomingSessionCount?performance?.upcomingSessionCount:"0"}</p>
                    <p className="perf-rating-body">30- Day upcoming sessions</p>
                </Col>
            </Row>
        </div>
    </div>
}